import { createSlice, Draft, PayloadAction } from '@reduxjs/toolkit';

import { ICultureDTO, LocalizationsDTO } from 'src/api/dtos';
import { IError } from 'src/api/types';

import { fetchCultures, fetchLocalizations } from './localizations.actions';
import { ILocalizationsState } from './localizations.types';

const initialState: ILocalizationsState = {
  data: {},
  cultures: [],
  loading: false,
  error: null,
};

export const localizationSlice = createSlice({
  name: 'localizations',
  initialState,
  reducers: {},
  extraReducers: (build) => {
    /* fetchLocalizations */
    build.addCase(
      fetchLocalizations.fulfilled.type,
      (state: Draft<ILocalizationsState>, { payload }: PayloadAction<LocalizationsDTO>) => {
        return {
          ...state,
          data: payload,
          loading: false,
        };
      },
    );
    build.addCase(fetchLocalizations.pending.type, (state: Draft<ILocalizationsState>) => {
      return {
        ...state,
        error: null,
        loading: true,
      };
    });
    build.addCase(
      fetchLocalizations.rejected.type,
      (state: Draft<ILocalizationsState>, { payload }: PayloadAction<IError>) => {
        return {
          ...state,
          error: payload,
          loading: false,
        };
      },
    );
    /* fetchCultures */
    build.addCase(
      fetchCultures.fulfilled.type,
      (state: Draft<ILocalizationsState>, { payload }: PayloadAction<ICultureDTO[]>) => {
        return {
          ...state,
          cultures: payload,
        };
      },
    );
    build.addCase(
      fetchCultures.rejected.type,
      (state: Draft<ILocalizationsState>, { payload }: PayloadAction<IError>) => {
        return {
          ...state,
          error: payload,
        };
      },
    );
  },
});
